export default __webpack_public_path__ + "static/media/slash.40c1c466.svg";